export default __webpack_public_path__ + "static/media/forestly-expl-02_EN.8471ac52.png";